import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function UnitsPage() {
    const columns = useMemo(() => [
        { key: 'name', label: 'Unit' },
        { key: 'short_name', label: 'Short Name' },
        { key: 'usage_count', label: 'No of Products' },
        { key: 'created_at', label: 'Created Date', render: (row) => new Date(row.created_at).toLocaleDateString() },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Units"
            type="unit"
            columns={columns}
            fields={[
                { name: 'name', label: 'Unit Name' },
                { name: 'short_name', label: 'Short Name', placeholder: 'e.g. pcs, kg, box' },
                { name: 'description', label: 'Description', type: 'textarea' },
            ]}
            buildPayload={(form) => ({
                name: form.name,
                short_name: form.short_name,
                description: form.description,
                status: form.status,
            })}
        />
    );
}
